/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerIngestDocumentMutationResponse, DocumentUseCasesControllerIngestDocument400, DocumentUseCasesControllerIngestDocument401, DocumentUseCasesControllerIngestDocument403 } from "../../models/documentUseCasesController/DocumentUseCasesControllerIngestDocument";

function getDocumentUseCasesControllerIngestDocumentUrl() {
  const res = { method: 'POST', url: `/api/v1/documents/ingestions` as const }  
  return res
}

/**
 * @description Creates a document ingestion operation that will create a single logical document from a file (assumes file contains only one document) and sets up processing workflow. Returns the operation resource with status and related document/job information.
 * @summary Create a document ingestion operation
 * {@link /api/v1/documents/ingestions}
 */
export async function documentUseCasesControllerIngestDocument(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerIngestDocumentMutationResponse, ResponseErrorConfig<DocumentUseCasesControllerIngestDocument400 | DocumentUseCasesControllerIngestDocument401 | DocumentUseCasesControllerIngestDocument403>, unknown>({ method : "POST", url : getDocumentUseCasesControllerIngestDocumentUrl().url.toString(), ... requestConfig })  
  return res.data
}